import React from 'react';
import { toastr } from 'react-redux-toastr';
import { toTitleCase } from '../../../lib/utils';

export default class PaginatedTable extends React.Component {

    componentWillMount() {
        if(!this.props.noReload) {
            const tableSettings = this.props.records.length ? [this.props.page, this.props.resultsView, this.props.sort] : [];
            this.props.loadData(...tableSettings);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (!nextProps.success && this.props.success) {
            toastr.error("Something went wrong", `We couldn't retrieve ${this.props.name || "records"}.  Please try again`);
        }
    }

    sortTable(column) {
        const sort = {
            by: column.id,
            direction: this.props.sort.by !== column.id
                ? (column.defaultDirection ? column.defaultDirection : "Ascending")
                : (this.props.sort.direction === "Ascending" ? "Descending" : "Ascending")
        };
        this.props.sortData({ sort });
        this.props.loadData(1, this.props.resultsView, sort);
    }

    changeResultsView(event) {
        const pageUpdate = event.target.value < 12 ? 1 : Math.floor((this.props.resultsView * this.props.page) / event.target.value) || 1;
        this.props.changeDataView({ resultsView: event.target.value });
        this.props.loadData(pageUpdate, event.target.value, this.props.sort);
    }

    paginate(page) {
        if (!this.props.loading) {
            this.props.loadData(page, this.props.resultsView, this.props.sort);
            window.scrollTo({ "behavior": "smooth", "left": 0, "top": 0 });
        }
    }

    getHeader() {
        return this.props.columns.filter(column => !column.hidden).map(column => {
            return <th key={column.id} className={column.className || ''}>
                <div className="relative">
                    {column.component || <div className={`sort flex-center ${this.props.sort && this.props.sort.by === column.id ? "active" : ""}`}>
                        {
                            column.icon ? <i className="material-icons large-text">{column.icon}</i>
                        : <p className="sort-arrows-label">{column.title}</p>
                        }
                        {column.sortable &&
                            <div className="sort-arrows relative" onClick={this.sortTable.bind(this, column)}>
                                <i className={`icon ion-android-arrow-dropup ${this.props.sort.direction !== 'Ascending' ? "inactive" : ""}`}></i>
                                <i className={`icon ion-android-arrow-dropdown ${this.props.sort.direction !== 'Descending' ? "inactive" : ""}`}></i>
                            </div>
                        }
                    </div>}
                </div>
            </th>
        });
    }

    getRows() {
        return this.props.records.map(item => this.props.renderRow(item));
    }

    getPaginationFooter() {
        let numberOfPages = Math.ceil((this.props.totalCount || 0) / this.props.resultsView);
        if (numberOfPages < 2) {
            return <ul className="pagination"></ul>;
        }

        let pagesArray = Array(numberOfPages).fill().map((_, i) => i + 1);
        if (this.props.page > 6 && numberOfPages > 10) {
            let startPg = this.props.page - 6;
            if ((numberOfPages - startPg) < 10) startPg = numberOfPages - 10;
            pagesArray = pagesArray.slice(startPg, pagesArray.length);
        }
        if (pagesArray.length > 10) pagesArray = pagesArray.slice(0, 10);

        return <ul className={`pagination ${this.props.loading ? "disabled" : ""}`}>
            <li key='prev' className={(this.props.page > 1) ? "fade-in" : "fade-out"} onClick={this.paginate.bind(this, this.props.page - 1)}>Prev</li>
            {pagesArray.map(pg =>
                <li key={pg} className={this.props.page.toString() === pg.toString() ? "active" : ""} onClick={this.paginate.bind(this, pg)}>{pg}</li>
            )}
            <li key='next' className={(this.props.page < pagesArray[pagesArray.length - 1]) ? "fade-in" : "fade-out"} onClick={this.paginate.bind(this, this.props.page + 1)}>Next</li>
        </ul>;
    }

    getResultsView() {
        return this.props.totalCount > 12 && <div className="custom-select">
            <select value={this.props.resultsView} onChange={this.changeResultsView.bind(this)}>
                {Array(4).fill().map((_, i) => ++i * 12).map(resultSize =>
                    <option key={resultSize} value={resultSize}>Show {resultSize} Results</option>)}}
            <option value={90}>Show 90 Results</option>
            <option value={250}>Show 250 Results</option>
            <option value={this.props.totalCount || 0}>Show All Results</option>
            </select>
            <i className="material-icons">arrow_drop_down</i>
        </div>;
    }

    render() {
        return (
            <div className="container">
                {(!this.props.loading && !this.props.records.length)
                    ? <p className="empty-state">
                        <i className="material-icons">not_interested</i>
                        <span>No {this.props.name ? toTitleCase(this.props.name) : 'Records'} Found</span>
                    </p>
                    : <div>
                        <div className="table-container">
                            {this.props.loading && <div className="row table-loader-row">
                                <div className="table-view__loader loader-row">
                                    <div className="loader-row__cell lrc-1"></div>
                                    <div className="loader-row__cell lrc-2"></div>
                                    <div className="loader-row__cell lrc-3"></div>
                                    <div className="loader-row__cell lrc-4"></div>
                                    <div className="loader-row__cell lrc-5"></div>
                                    <div className="loader-row__cell lrc-6"></div>
                                    <div className="loader-row__cell lrc-7"></div>
                                    <div className="loader-row__cell lrc-8"></div>
                                    <div className="loader-row__cell lrc-9"></div>
                                    <div className="loader-row__cell lrc-10"></div>
                                    <div className="loader-row__cell lrc-11"></div>
                                </div>
                            </div>}
                            <table className="table">
                                <thead>
                                    <tr className="table-header table-row">
                                        {this.getHeader()}
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.getRows()}
                                </tbody>
                            </table>
                        </div>
                        {this.props.records.length > 0 && !(this.props.hasOwnProperty('showFooter') && !this.props.showFooter) && <div className="table-footer">
                            {this.getPaginationFooter()}
                            {this.getResultsView()}
                        </div>}
                    </div>}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/commonComponents/util/PaginatedTable.jsx